import { proxy } from "valtio";

export const currentAccount = proxy({
  account: null,
  accounts: [],
  activeAccount: null,
  team: null,
  teams: [],
  activeTeam: null,
  event: null,
  events: [],
});
